import { render, staticRenderFns } from "./UserFiltersChips.vue?vue&type=template&id=5663ddfe"
import script from "./UserFiltersChips.vue?vue&type=script&lang=js"
export * from "./UserFiltersChips.vue?vue&type=script&lang=js"
import style0 from "./UserFiltersChips.vue?vue&type=style&index=0&id=5663ddfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports